import React from 'react';
import LayoutNamePromptContent from 'layoutManagement/LayoutNamePromptContent';

export interface DuplicateLayoutContentProps {
    layoutName: string;
    duplicateName: string;
    onDuplicateNameChanged: (name: string) => void;
    onEnter: () => void;
    error: string;
    isInvalid: boolean;
}

export default function DuplicateLayoutContent(
    props: DuplicateLayoutContentProps
) {
    const {
        layoutName,
        duplicateName,
        onDuplicateNameChanged,
        onEnter,
        error,
        isInvalid,
    } = props;

    return (
        <LayoutNamePromptContent
            className="DuplicateLayoutContent"
            title={`Create Duplicate of '${layoutName}'`}
            message={
                'You will be able to make modifications to the new layout without changing the original layout.'
            }
            label={'Duplicate Layout Name'}
            layoutName={duplicateName}
            onLayoutNameChanged={onDuplicateNameChanged}
            isInvalid={isInvalid}
            error={error}
            onEnter={onEnter}
        />
    );
}
